import {
  createContext,
  useContext,
} from "react";

import { DefaultComponentProps } from "../../store";
import { ServicePaginatedReturn, ServicePaginatedReturnData, ServiceReturn } from "../../types/ServiceResponse";
import { useApi } from "./useApiProvider";
import { Outlet } from "react-router-dom";

export interface StateProviderProps extends DefaultComponentProps {};

type ApiCallOptions = {
  showSuccessMessage?: boolean;
  showErrorMessage?: boolean;
};

export interface UseApiContext {
  simpleApiCall:
    <Req, Res>(
      callback: ( payload: Req, token?: string ) => Promise<ServiceReturn<Res>>,
      payload: Req,
      toggleLoading?: () => void,
      options?: ApiCallOptions,
    ) => Promise<Res | null>;
  paginatedApiCall:
    <Req, Res>(
      callback: ( payload: Req, token?: string ) => Promise<ServicePaginatedReturn<Res>>,
      payload: Req,
      toggleLoading?: () => void,
      options?: ApiCallOptions,
    ) => Promise<ServicePaginatedReturnData<Res> | null>;
};

export const apiContext = createContext<UseApiContext>({
  simpleApiCall:async (
    callback,
    payload,
    toggleLoading,
    options,
  ) => null,
  paginatedApiCall: async (
    callback,
    payload,
    toggleLoading,
    options,
  ) => null,
});

const { Provider } = apiContext;

export const ApiProvider = () => {
  const apiProvider = useApi();

  return (
    <Provider
      value={{
        ...apiProvider,
      }}
    >
      <Outlet />
    </Provider>
  );
};

export const useApiProvider = () => useContext( apiContext );
